<template>
  <div>
    <v-card class="">
      <template-text></template-text>
      <v-layout column class="mt-1 pa-0">
        <template-button></template-button>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import templateText from './templateFragments/templateText'
import templateButton from './templateFragments/templateButton'
export default {
  data () {
    return {
      id: ''
    }
  },
  components: {
    templateText,
    templateButton
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.template-edit-area{
  box-shadow: 0 0 1px rgba(0,0,0,2);
  padding: 0px 0px 1px 0px;
  border-bottom: 1px;
  padding: 0;
  border-radius: 0px 0px 10px 10px;
  background: #f4f4f4;
  border: 0px
}
</style>



// WEBPACK FOOTER //
// src/components/push/components/pushTemplateText.vue